import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { mockDelay } from '@/shared/api/mockDelay';
import type { OrgTreeNode } from '../model/organizationSchema';
import { orgTree as orgTreeMock } from './mockData';
import { readOrgTreeOverride, writeOrgTreeOverride } from './orgTreeStorage';
import { fetchOrgUnitsTree, type OrgUnitsTreeParams } from './orgUnitsApi';

function mergeOrgTree(): OrgTreeNode[] {
  return readOrgTreeOverride() ?? orgTreeMock;
}

/** GET /api/organization/tree (legacy mock) */
export function useOrgTree() {
  return useQuery({
    queryKey: ['orgTree'],
    queryFn: () => mockDelay(mergeOrgTree()),
  });
}

/** PUT /api/organization/tree — полное дерево после правок (мок через localStorage). */
export function useReplaceOrgTree() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (next: OrgTreeNode[]) => {
      writeOrgTreeOverride(next);
      await mockDelay(null);
      return next;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['orgTree'] });
    },
  });
}

/** GET /v1/org-units/tree — дерево оргструктуры (lazy, depth=1). */
export function useOrgUnitsTree(params: OrgUnitsTreeParams = {}) {
  return useQuery({
    queryKey: ['org-units', 'tree', params],
    queryFn: () => fetchOrgUnitsTree(params),
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
}
